// src/pages/item_delivery_logs/ItemDeliveryLogList.js
import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
  Box,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import itemDeliveryLogService from '../../services/itemDeliveryLogService';
import LayoutContainer from '../../components/LayoutContainer';
import AdminHeader from '../../components/AdminHeader';

const ItemDeliveryLogList = () => {
  const [itemDeliveryLogs, setItemDeliveryLogs] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchItemDeliveryLogs = async () => {
      const response = await itemDeliveryLogService.getItemDeliveryLogs();
      setItemDeliveryLogs(response.data);
    };
    fetchItemDeliveryLogs();
  }, []);

  const handleDelete = async (id) => {
    await itemDeliveryLogService.deleteItemDeliveryLog(id);
    setItemDeliveryLogs(
      itemDeliveryLogs.filter((itemDeliveryLog) => itemDeliveryLog.id !== id)
    );
  };

  return (
    <LayoutContainer>
      <AdminHeader title='Item Delivery Logs' />
      <div className='page-content-wrapper scrollable'>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            sx={{ backgroundColor: '#be210b', textTransform: 'none' }}
            onClick={() => navigate('/item-delivery-logs/new')}
          >
            Add Item Delivery Log
          </Button>
        </Box>
        <Table className='table'>
          <TableHead className='tableHead'>
            <TableRow>
              <TableCell>Delivery</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Timestamp</TableCell>
              <TableCell>Details</TableCell>
              <TableCell>Photo</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className='tableBody'>
            {itemDeliveryLogs.map((itemDeliveryLog) => (
              <TableRow key={itemDeliveryLog.id}>
                <TableCell>{itemDeliveryLog.delivery_id}</TableCell>
                <TableCell>{itemDeliveryLog.action}</TableCell>
                <TableCell>
                  {new Date(itemDeliveryLog.timestamp).toLocaleString()}
                </TableCell>
                <TableCell>{itemDeliveryLog.details}</TableCell>
                <TableCell>
                  {itemDeliveryLog.photo ? (
                    <img src={itemDeliveryLog.photo} alt='Log' width='50' />
                  ) : (
                    'No Photo'
                  )}
                </TableCell>
                <TableCell>
                  <IconButton
                    onClick={() =>
                      navigate(`/item-delivery-logs/edit/${itemDeliveryLog.id}`)
                    }
                  >
                    <EditIcon sx={{ color: '#be210b' }}/>
                  </IconButton>
                  <IconButton onClick={() => handleDelete(itemDeliveryLog.id)}>
                    <DeleteIcon sx={{ color: '#be210b' }}/>
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </LayoutContainer>
  );
};

export default ItemDeliveryLogList;
